import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            demand: { id: 0 },
            originalOwner: { id: 0 },
            substituteOwner: { id: 0 },
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/DemandOwnerSubstitution.js